import React from "react";
import SectionHeading from "../../common/headings/SectionHeading";
import DepositCalculatorBody from "../calculator-body/Main";

const DepositCalculatorHead = ({ headData, bodyData, keyword }) => {
  const {
    calculate_button,
    desclaimer,
    desclaimer_color,
    arrow_icon,
    hero_images,
  } = headData !== undefined && headData;
  return (
    <div className="md:flex flex-none md:bg-[#E7E6F2] bg-[#D6D7EC] w-[90%] m-auto rounded-3xl pl-[5vw] relative min-h-[32vw] md:mt-[3vw] mt-[8vw] md:mb-[3vw] mb-[5vw]">
      <div className="md:w-[85%] w-[100%] md:pt-[3vw] pt-[5vw] md:pb-0 pb-[60vw]">
        <div>
          <SectionHeading
            lable={headData?.title}
            lable_color={headData?.title_color}
          />
        </div>
        <DepositCalculatorBody
          data={bodyData}
          arrow_icon={arrow_icon}
          buttonData={calculate_button}
          hero_images={hero_images}
          keyword={keyword}
        />
        <div className="md:text-[0.8vw] text-[3vw] mt-[3vw] md:w-[55%] w-[90%]">
          <span className="font-krubSemibold">*Disclaimer : </span>
          <span style={{ color: desclaimer_color }} className="font-krubMedium">
            {desclaimer}
          </span>
        </div>
      </div>
    </div>
  );
};

export default DepositCalculatorHead;
